import lightGreen from "@material-ui/core/colors/lightGreen";
import red from "@material-ui/core/colors/red";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import {
  StyledComponentProps,
  StyleRulesCallback,
  Theme,
  withStyles,
} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { subMonths } from "date-fns";
import * as React from "react";
import { connect } from "react-redux";
import {
  CartesianGrid,
  Label,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import { Dispatch, StoreState } from "../store";
import { DashboardFilterState, Score } from "../types/index";
import { format, numberFormat } from "../utilities";
import ProgressOverlay from "./ProgressOverlay";

function mapStateToProps({ dashboardFilter, lineChartsData }: StoreState) {
  return {
    dashboardFilter,
    lineChartsData,
  };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    fetchLineChartsData: (dashboardFilter: DashboardFilterState) =>
      dispatch.lineChartsData.fetchLineChartsData(dashboardFilter),
  };
}

type Props = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;
class LineChartComponent extends React.Component<Props & StyledComponentProps> {
  public async componentDidMount() {
    this.props.fetchLineChartsData(this.props.dashboardFilter);
  }

  public async componentDidUpdate(prevProps: Props) {
    if (prevProps.dashboardFilter !== this.props.dashboardFilter) {
      this.props.fetchLineChartsData(this.props.dashboardFilter);
    }
  }

  public render() {
    const { classes, dashboardFilter } = this.props;
    const color =
      this.props.dashboardFilter.score === Score.CLV
        ? lightGreen[900]
        : red[900];
    const labelAndAxisColor = "#666666";
    const scoreLabel =
      dashboardFilter.score === Score.CHURN ? "Churn Score" : "CLV";
    const startDateLabel = format(
      subMonths(new Date(), dashboardFilter.dateRange),
      "MMMM yyyy"
    );
    const endDateLabel = format(new Date(), "MMMM yyyy");

    return (
      <Paper className={classes && classes.paper}>
        <ProgressOverlay loading={this.props.lineChartsData.loading}>
          <Grid container={true} spacing={2}>
            <Grid item={true} xs={12} lg={12}>
              <Typography variant="h6">
                Entwicklung {scoreLabel} für {startDateLabel} bis {endDateLabel}
              </Typography>
              <Typography component="div">
                <ResponsiveContainer width="100%" height={300}>
                  <LineChart
                    data={this.props.lineChartsData.timestampData}
                    margin={{
                      bottom: 5,
                      left: 20,
                      right: 30,
                      top: 5,
                    }}
                  >
                    <CartesianGrid />
                    <XAxis dataKey="date" stroke={labelAndAxisColor} />
                    <YAxis
                      stroke={labelAndAxisColor}
                      tickFormatter={(v: any) => numberFormat(Number(v), true)}
                    >
                      <Label
                        angle={-90}
                        fill={labelAndAxisColor}
                        value="Durchschnitt Churn Score"
                        position="insideLeft"
                        style={{ textAnchor: "middle" }}
                        width={200}
                      />
                    </YAxis>
                    <Tooltip
                      formatter={(v: any) => numberFormat(Number(v), true)}
                    />
                    <Line
                      type="monotone"
                      dataKey="avg"
                      name={`Durchschnitt ${
                        this.props.dashboardFilter.score === Score.CLV
                          ? "CLV"
                          : "Churn Score"
                      }`}
                      stroke={color}
                    />
                  </LineChart>
                </ResponsiveContainer>
              </Typography>
            </Grid>
          </Grid>
        </ProgressOverlay>
      </Paper>
    );
  }
}

const styles: StyleRulesCallback<Theme, Props> = (theme: Theme) => ({
  paper: {
    padding: theme.spacing(2),
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(LineChartComponent));



// WEBPACK FOOTER //
// ./src/components/LineChartComponent.tsx